function SMTPSettings({
    value: state,
    onChange = () => { }
}) {


    function handleChange(evt) {
        const value = evt.target.value;
        // setState({
        //     ...state,
        //     [evt.target.name]: value
        // });
        onChange({
            ...state,
            [evt.target.name]: value
        });
    }

    console.log("Internal State: " + JSON.stringify(state))

    return (
        <>
            <div className="row">
                <h5 className="text-muted"><i className="fa-solid fa-server"></i> Email Server</h5>
                <div className="col-md-3 mb-3">
                    <label htmlFor="employeeFirstName">SMTP Server</label>
                    <input type="text" className="form-control" name="server" onChange={handleChange} value={state.server} placeholder="smtp.domain.com" required />
                    <div className="invalid-feedback">
                        Valid first name is required.
                    </div>
                </div>
                <div className="col-md-1 mb-3">
                    <label htmlFor="lastName">Port</label>
                    <input type="text" role="presentation" className="form-control" name="port" onChange={handleChange} value={state.port} placeholder="456" />
                    <div className="invalid-feedback">
                        Valid last name is required.
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-2 mb-3">
                    <label htmlFor="lastName">Username</label>
                    <input type="text" role="presentation" className="form-control" name="username" onChange={handleChange} value={state.username} placeholder="" />
                    <div className="invalid-feedback">
                        Valid last name is required.
                    </div>
                </div>
                <div className="col-md-2 mb-3">
                    <label htmlFor="lastName">Password</label>
                    <input type="text" role="presentation" className="form-control" name="password" onChange={handleChange} value={state.password} placeholder="" />
                    <div className="invalid-feedback">
                        Valid last name is required.
                    </div>
                </div>
            </div>
        </>

    )
}

export default SMTPSettings